import { TraxPermission } from 'src/app/core/models/trax-permission.model';

/**
 * configuration for the shared location-assignment component. "Assign Alerts/QC Locations" and "Assign Inspection Locations" render the same component and
 * differ only in these values, which the router supplies through `route.data.screenConfig`.
 */
export interface LocationAssignmentScreenConfig {
  /** Heading and toast label, e.g. "Assign Alerts/QC Locations". */
  screenTitle: string;

  /** Endpoint to fetch the user list dropdowm. */
  userListEndpoint: string;

  /** Endpoint that returns the grid + assigned groups for a user (per assignment type). */
  detailsEndpoint: string;

  /** Endpoint that saves the user's direct + group assignments (per assignment type). */
  saveEndpoint: string;

  /** Whether the "In Your Zone" column may be shown. */
  showInYourZone: boolean;

  /** Whether the "View Unassigned Locations" action button is shown. */
  showUnassignedLocations: boolean;

  /** Permission that gates editing/saving on this screen. */
  editPermission: TraxPermission;

  /** Permission that gates the "View Unassigned Locations" action. */
  viewUnassignedPermission?: TraxPermission;
}

/** Assign Alerts/QC Locations screen */
export const ALERT_ASSIGNMENT_CONFIG: LocationAssignmentScreenConfig = {
  screenTitle: 'Assign Alerts/QC Locations',
  userListEndpoint: 'admin/all/restroom/assignment/users/-1/-1',
  detailsEndpoint: 'v2/facility/location-assignment/details',
  saveEndpoint: 'v2/facility/location-assignment',
  showInYourZone: true,
  showUnassignedLocations: true,
  editPermission: TraxPermission.LOCATION_ASGMT_EDIT,
  viewUnassignedPermission: TraxPermission.LOCATION_ASGMT_VIEW_UNASSIGNED_LOCATION,
};

/** Assign Inspection Locations screen */
export const INSPECTION_ASSIGNMENT_CONFIG: LocationAssignmentScreenConfig = {
  screenTitle: 'Assign Inspection Locations',
  userListEndpoint: 'inspection/location/assignment/inspectors',
  detailsEndpoint: 'v2/facility/inspection-location-assignment/details',
  saveEndpoint: 'v2/facility/inspection-location-assignment',
  showInYourZone: false,
  showUnassignedLocations: false,
  editPermission: TraxPermission.INSPECTION_LOCATION_ASGMT_EDIT,
};
